import React, { useState, useEffect } from "react";

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label,
  FormGroup,
  Alert,
} from "reactstrap";
import axios from "axios";
import { END_POINT } from "../../constants/defaultValues";
import { NotificatioSucController } from "../../helpers/Utils";
import AffiliateLayout from "./layout";

const Campaigns = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCampaigns();
  }, []);

  const fetchCampaigns = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("affiliate_token");
      const res = await axios.get(`${END_POINT}/api/affiliate/campaigns`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("affiliate_token")}`,
        },
      });
      if (res.data && res.data.data) {
        setCampaigns(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching campaigns:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AffiliateLayout title="Chiến dịch">
        <div className="aff-page-container">
          <div className="page-header">
            <h2>Chiến dịch Marketing</h2>
            <p>Danh sách các chiến dịch tiếp thị liên kết hiện có.</p>
          </div>

          <div className="aff-card">
            <div className="card-header">
              <h3>Tất cả chiến dịch</h3>
            </div>
            <div className="aff-table-container">
              {loading ? (
                <div className="p-4 text-center">
                  <div className="simple-spinner"></div>
                </div>
              ) : (
                <table>
                  <thead>
                    <tr>
                      <th>Tên chiến dịch</th>
                      <th>Mã (Code)</th>
                      <th className="text-center">Click</th>
                      <th className="text-center">Đăng ký</th>
                      <th className="text-center">Khách hàng</th>
                      <th className="text-right">Doanh thu</th>
                      <th className="text-right">Hoa hồng</th>
                      <th>Trạng thái</th>
                    </tr>
                  </thead>
                  <tbody>
                    {campaigns.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center p-4">
                          Chưa có chiến dịch nào. Vui lòng liên hệ Admin để được
                          cấp link.
                        </td>
                      </tr>
                    ) : (
                      campaigns.map((camp) => {
                        const link =
                          camp.links && camp.links.length > 0
                            ? camp.links[0]
                            : null;
                        const affLink = link
                          ? `https://vmass.vn?ref=${link.code}`
                          : "N/A";

                        return (
                          <tr key={camp.id}>
                            <td>
                              <div className="font-medium text-slate-800">
                                {camp.name}
                              </div>
                              <div className="text-xs text-slate-500">
                                {new Date(camp.createdAt).toLocaleDateString(
                                  "vi-VN",
                                )}
                              </div>
                            </td>
                            <td>
                              {link && (
                                <>
                                  <div className="d-flex align-items-center mb-1">
                                    <code className="bg-slate-100 px-2 py-1 rounded text-xs font-mono text-slate-600 mr-2">
                                      {link.code}
                                    </code>
                                  </div>
                                  <div className="d-flex align-items-center text-muted text-xs truncate max-w-xs">
                                    <span className="mr-1 truncate">
                                      {affLink}
                                    </span>
                                    <i
                                      className="simple-icon-docs text-primary cursor-pointer hover-scale"
                                      onClick={() => {
                                        navigator.clipboard.writeText(affLink);
                                        NotificatioSucController(
                                          "Đã sao chép liên kết!",
                                        );
                                      }}
                                      title="Sao chép liên kết"
                                      style={{ fontSize: "12px" }}
                                    />
                                  </div>
                                </>
                              )}
                            </td>
                            <td className="text-center">
                              {camp.stats?.clicks?.toLocaleString() || 0}
                            </td>
                            <td className="text-center">
                              {camp.stats?.registrations?.toLocaleString() || 0}
                            </td>
                            <td className="text-center">
                              {camp.stats?.paid_users?.toLocaleString() || 0}
                            </td>
                            <td className="text-right">
                              {new Intl.NumberFormat("vi-VN", {
                                style: "currency",
                                currency: "VND",
                              }).format(camp.stats?.revenue || 0)}
                            </td>
                            <td className="text-right font-weight-bold text-success">
                              {new Intl.NumberFormat("vi-VN", {
                                style: "currency",
                                currency: "VND",
                              }).format(camp.stats?.commission || 0)}
                            </td>
                            <td>
                              <span
                                className={`status-badge ${
                                  camp.status === "active"
                                    ? "approved"
                                    : "pending"
                                }`}
                              >
                                {camp.status === "active"
                                  ? "Hoạt động"
                                  : camp.status}
                              </span>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </AffiliateLayout>
    </>
  );
};

export default Campaigns;
